import { apiRequest } from './index';

export const fetchSssRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/ssss/' + id, {}, success, failure);
}

export const fetchSsssRequest = ( selectedDate, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/ssss?selectedDate=${selectedDate}`, {}, success, failure);
}

export const createSssRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/ssss',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const createSssGroupRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/ssss/group',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editSssRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/ssss/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deleteSssRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/ssss/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}

export const getEffectiveDateList = ( success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/ssss/effective-date/list',
        { method: 'GET' },
        success,
        failure
    )
}
